<template>
    <form-partition :title="title" ref="info" :rules="innerRules" :model="info">
        <loading-animation v-if="loading" />
        <div v-else>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem
                        :required="!justRead"
                        prop="leaseDate"
                        :label="type === '2' ? ' 新租约租期' : '合同起止'"
                    >
                        <se-date-picker
                            :startDate="info.startDate"
                            :endDate="info.endDate"
                            ref="datePickerInfo"
                            spread-out
                            @on-change="onChangeDate"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="buildArea" label="建筑面积">
                        <input-number
                            v-if="!justRead || (info.buildArea && justRead)"
                            v-model="info.buildArea"
                            placeholder
                            :min="0"
                            @on-blur="buildAreaChange(info)"
                        >
                            <span slot="append">㎡</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem prop="unitPrice" label="单价">
                        <input-number
                            v-if="!justRead || (info.unitPrice && justRead)"
                            v-model="info.unitPrice"
                            placeholder
                            :min="0"
                            @on-blur="unitPriceChange(info)"
                        >
                            <span slot="append">元/㎡/月</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="4">
                    <FormItem prop="priceRemark" :label-width="-15">
                        <Input
                            v-if="!justRead || (info.priceRemark && justRead)"
                            v-model="info.priceRemark"
                            placeholder="备注文字"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="rent" label="租金">
                        <input-number
                            v-model="info.rent"
                            placeholder
                            :min="0"
                            @on-blur="
                                rentChange(info, !isDepositPayMethodDisable)
                            "
                        >
                            <span slot="append">元/月</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12" style="position: relative">
                    <FormItem prop="rentMode" label="交租方式">
                        <!-- 换房4与续租2，交租方式不能更改，继承原合同的方式 -->
                        <rent-mode
                            isVerify
                            spread-out
                            :depositPayMethod="info.depositPayMethod"
                            :rentPayMethod="info.rentPayMethod"
                            :depositPayMethodDisable="isDepositPayMethodDisable"
                            :isTranslation="depositHandleType === '2'"
                            @on-change="changeRentMode"
                        />
                    </FormItem>
                    <Button
                        style="position: absolute; left: 240px; top: 0px"
                        v-if="$can('view') && justRead && isRentCustom"
                        type="primary"
                        ghost
                        @click="modal.showRentCustom = true"
                    >
                        查看自定义账期
                    </Button>
                </Col>
            </Row>
            <Row :gutter="20" v-if="isAddAmountAndLeftAmount">
                <Col span="12">
                    <FormItem prop="addAmount" label="增收押金">
                        <input-number
                            v-model="info.addAmount"
                            placeholder
                            @on-blur="changeBill"
                        >
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="leftAmount" label="原合同结转金额">
                        <!-- v-show="false"，不显示，用于数据收集 -->
                        <input-number
                            v-show="false"
                            :value="info.leftAmount"
                            placeholder
                            viewonly
                        >
                            <span slot="append">元(押金)</span>
                        </input-number>
                        <span>{{ leaseLeftAmountText }}</span>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20" v-else>
                <Col span="12">
                    <FormItem prop="deposit" label="常规押金">
                        <input-number
                            v-model="info.deposit"
                            placeholder
                            :min="0"
                            :disabled="!isDepositEdit"
                        >
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12" v-if="justRead && info.addAmount">
                    <FormItem prop="addAmount" label="增收押金">
                        <input-number v-model="info.addAmount" placeholder>
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
                <!-- 预定显示定金 -->
                <Col span="12" v-if="isBook">
                    <FormItem prop="resAmount" label="定金" viewonly>
                        <input-number
                            :value="info.resAmount"
                            placeholder
                            :min="0"
                        >
                            <span slot="append">
                                元 ({{
                                    info.receiveStatus === '1'
                                        ? '未收款'
                                        : '已收款'
                                }})
                            </span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="otherDeposit" label="其它押金">
                        <other-deposit
                            @input="changeBill"
                            :value="info.otherDeposit"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="increase" label="租金涨幅">
                        <rent-increase-period
                            v-if="isRentCustom"
                            :value="info.increase"
                            :startDate="info.startDate"
                            :endDate="info.endDate"
                            :rentPayMethod="info.rentPayMethod"
                            :mergeList="info.mergeList"
                            @input="changeBill"
                        />
                        <rent-increase
                            v-else
                            :value="info.increase"
                            :year-span="increaseYear"
                            @input="changeBill"
                        />
                    </FormItem>
                </Col>
                <Col span="12" v-if="isBook && info.receiveStatus === '2'">
                    <FormItem prop="depositOffset" label="定金抵扣">
                        <check-tag-group
                            style="display: inline-block"
                            v-model="info.depositOffset"
                            color="primary"
                            @on-change="changeBill"
                        >
                            <check-tag
                                :name="item.id"
                                v-for="item in depositOffsetList"
                                :key="item.id"
                            >
                                {{ item.text }}
                            </check-tag>
                        </check-tag-group>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="discount" label="租金优惠">
                        <rent-discount
                            @input="changeBill"
                            @on-type-change="changeDiscountType"
                            :value="info.discount"
                            :discountType="info.discountType"
                            :startDate="info.startDate"
                            :endDate="info.endDate"
                            :rentPayMethod="info.rentPayMethod"
                            :mergeList="info.mergeList"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="otherFee" label="其它费用">
                        <other-fee @input="changeBill" :value="info.otherFee" />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="rentDay" label="收租日设置">
                        <rent-day
                            :receiveRentValue="info.receiveRentValue"
                            :receiveRentType="info.receiveRentType"
                            @on-change="changeBill"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="signUser" label="签约人">
                        <Input :value="info.signUser" disabled />
                    </FormItem>
                </Col>
                <Col span="12" style="position: relative">
                    <FormItem
                        prop="attachments"
                        label="添加附件"
                        :viewonly="false"
                    >
                        <preview-upload
                            v-model="info.attachments"
                            multiple
                            :selfFileName="selfFileName"
                        />
                    </FormItem>
                    <div style="position: absolute; left: 70px; bottom: 10px">
                        上传身份证正反面
                    </div>
                </Col>
            </Row>
            <Row :gutter="20" v-if="info.agentUser">
                <Col span="12">
                    <FormItem prop="agentUser" label="经办人">
                        <Input :value="info.agentUser" disabled />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="fList" label="交接清单">
                        <facility-list
                            v-model="info.fList"
                            :remark="fListRemark"
                            @input="confirmFacilityList"
                            @remark-change="remarkChange"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="remark" label="备注">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="3"
                            placeholder
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20" v-show="false">
                <Col span="24">
                    <FormItem prop="mergeList" label="账期合并列表，不显示">
                        <Input
                            v-model="info.mergeList"
                            type="textarea"
                            :rows="3"
                            placeholder
                        />
                    </FormItem>
                </Col>
            </Row>
        </div>
        <!-- 弹出层 @close-by-confirm="search"-->
        <smart-modal
            v-model="modal.showRentCustom"
            title="自定义账期"
            :width="800"
            :height="500"
            :maskClosable="false"
            @close-by-confirm="changeBill"
            @on-cancel="onCloseModal"
        >
            <rent-custom-form
                v-if="modal.showRentCustom"
                :startDate="ymd(info.startDate)"
                :endDate="ymd(info.endDate)"
                @on-confirm="confirmRentCustom"
                :mergeList="info.mergeList"
                :viewonly="justRead"
            />
        </smart-modal>
    </form-partition>
</template>
<script>
import { Field } from 'ivux'
import Dict from '_u/dict'
import { debounce, ymd } from '_u/helper'
import {
    buildAreaChange,
    changeRentMode,
    rentChange,
    unitPriceChange,
} from '@/views/common/u-rent'

import { cInfoList } from '@/api/customer'
import { contractUpdateAttach } from '@/api/contract'

import SeDatePicker from '_vc/fields/se-date-picker'
import RentMode from '_vc/fields/rent-mode'
import RentIncrease from '_vc/fields/rent-increase'
import RentIncreasePeriod from '_vc/fields/rent-increase-period'
import RentDiscount from '_vc/fields/rent-discount'
import OtherFee from '_vc/fields/other-fee'
import OtherDeposit from '_vc/fields/other-deposit'
import RentDay from '_vc/fields/rent-day'
import PreviewUpload from '_c/preview-upload'
import FacilityList from '_vc/fields/facility-list'
import LoadingAnimation from '_v/components/loading-animation'
import RentCustomForm from './rent-custom-form'
import dayjs from 'dayjs'

export default {
    name: 'LeaseInfo',

    mixins: [Field],

    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        // 合同操作类型 CONTRACT_SCENE
        type: {
            type: [Number, String],
            default: '0',
        },
        title: {
            type: String,
            default: '租约信息',
        },
        justRead: {
            type: Boolean,
            default: false,
        },
        isBook: {
            type: Boolean,
            default: false,
        },
        populateType: {
            type: String,
            default: 'through',
        },
        // 押金处理方式 1 退还 ； 2 平移
        depositHandleType: {
            type: String,
            default: '',
        },
        // 押金是否已收
        isRecvDeposit: {
            type: Boolean,
            default: false,
        },
        // 下载附件名称
        selfFileName: {
            type: String,
            default: '',
        },
        // 其他押金与常规押金进行拼接字符串
        leaseLeftAmountText: {
            type: String,
            default: '',
        },
    },
    components: {
        SeDatePicker,
        RentMode,
        RentIncrease,
        RentIncreasePeriod,
        RentDiscount,
        OtherFee,
        OtherDeposit,
        RentDay,
        PreviewUpload,
        FacilityList,
        LoadingAnimation,
        RentCustomForm,
    },
    data() {
        return {
            loading: false,
            info: {
                id: '',
                ver: '',
                startDate: new Date(), // 合约开始日期
                endDate: '', // 预订租期结束日期
                buildArea: '', // 建筑面积
                buildArea: '', // 建筑面积
                unitPrice: '', // 单价
                rent: '', // 租金
                depositPayMethod: '', // 交租方式_押金
                rentPayMethod: '', // 交租方式
                deposit: '', // 押金
                addAmount: '', // 增收押金
                resAmount: '', // 定金
                depositOffset: [], // 定金转用类型
                receiveStatus: '', // 定金收款状态
                attachments: '', //上传附件
                signUser: '', // 签约人
                discount: [], // 租金优惠
                discountType: '3', // 租金优惠方式
                increase: [],
                receiveRentType: 1,
                receiveRentValue: 0,
                fList: [],
                leftAmount: '', // 原合同结转金额
                priceRemark: '', //单价备注文字
                mergeList: '[]', // 账期合并列表
            },
            increaseYear: 0, // 租金涨幅年
            fListRemark: '', // 物品清单备注
            dict: {
                cusType: Dict.NULL,
                depositOffset: Dict.NULL,
            },
            buildAreaChange: buildAreaChange,
            unitPriceChange: unitPriceChange,
            rentChange: rentChange,
            depositOffsetList: [], // 抵款方式列表
            modal: {
                showRentCustom: false, // 租金自定义弹框
            },
            ymd,
        }
    },
    watch: {
        value: {
            handler(val) {
                Object.assign(this.info, val)
            },
            immediate: true,
        },
        // 押金为平移，且未收，则原合同结转金额为0
        isRecvDeposit: {
            handler(val) {
                if (this.depositHandleType === '2' && !this.isRecvDeposit) {
                    this.info.leftAmount = 0
                }
            },
            immediate: true,
        },
        depositHandleType: {
            handler(val) {
                if (this.depositHandleType === '2' && !this.isRecvDeposit) {
                    this.info.leftAmount = 0
                }
            },
            immediate: true,
        },
        'info.attachments': {
            handler(val) {
                if (this.justRead) {
                    contractUpdateAttach({
                        id: this.info.id,
                        attachments: val, // 附件
                        ver: this.info.ver, // 版本号
                    }).finally(() => {
                        this.$emit('refresh-detail')
                    })
                }
            },
            deep: true,
        },
    },

    computed: {
        innerRules() {
            const validateRent = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('租金必填'))
                } else {
                    callback()
                }
            }

            const validateUnitPrice = (rule, value, callback) => {
                if (this.info.unitPrice === '') {
                    return callback(new Error('单价必填'))
                }

                if (this.info.unitPrice - this.info.minPrice < 0) {
                    return callback(
                        new Error(
                            '单价低于最低价' + this.info.minPrice + '，请调整'
                        )
                    )
                }
                return callback()
            }

            const validateBuildArea = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('建筑面积必填'))
                } else if (!(value - 0)) {
                    callback(new Error('建筑面积不能为0'))
                } else {
                    callback()
                }
            }
            let rule = {}
            // 详情
            if (this.justRead) {
                rule = {}
            }
            // 2 续租
            else if (this.type === '2') {
                rule = {
                    unitPrice: [{ validator: validateUnitPrice }],
                    rent: [
                        { validator: validateRent },
                        { required: true, message: '建筑面积必填' },
                    ],
                    rentMode: [{ required: true }],
                }
            } else {
                rule = {
                    buildArea: [
                        { validator: validateBuildArea, trigger: 'blur' },
                        { required: true, message: '建筑面积必填' },
                    ],
                    unitPrice: [{ validator: validateUnitPrice }],
                    deposit: [{ required: true, message: '押金必填' }],
                    rent: [
                        { validator: validateRent },
                        { required: true, message: '租金必填' },
                    ],
                    rentMode: [{ required: true }],
                }
            }

            return rule
        },

        // 押金可以更改-仅在交租方式押金自定义的时候
        isDepositEdit() {
            return this.info.depositPayMethod === '4'
        },

        // 押金交租方式不能更改
        isDepositPayMethodDisable() {
            // 退租场景
            return this.type === '2'
        },

        // 显示增收押金与原合同结转金额
        isAddAmountAndLeftAmount() {
            let flag = false
            // 换房
            if (this.type === '4') {
                // 押金退还，交租方式开放;押金平移，交租方式不开放
                if (this.depositHandleType === '2') {
                    flag = true
                }
            }
            // 退租
            else if (this.type === '2') {
                flag = true
            }
            return flag
        },

        // 租金交租方式是自定义
        isRentCustom() {
            return this.info.rentPayMethod === '20'
        },
    },
    created() {
        if (!this.info.signUser) {
            this.info.signUser = this.$store.state.user.info.nickName
        }
        this.fetch()
    },

    updated() {
        //以下代码存在bug，暂不启用
        // if (this.$refs.datePickerInfo.selectMode.length == 0){
        //   //页面初始化时，时间选择组件默认选中一年，是为了与止时间默认值相对应
        //   this.$refs.datePickerInfo.selectMode = [12]
        // }
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                Dict.get(['cus_type', 'deposit_offset']),
                cInfoList({ pageNo: 1, pageSize: 999 }),
            ])
                .then((args) => {
                    var [dictGroup, customer] = args
                    this.fListRemark =
                        this.info.fList.length > 0
                            ? this.info.fList[0].remark
                            : ''

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.customerList = customer.data.page.list
                    this.increaseYear = this.info.increase.length

                    this.depositOffsetList = this.dict.depositOffset.toList()
                    if (
                        this.depositOffsetList.length &&
                        !this.info.depositOffset.length
                    ) {
                        this.info.depositOffset = [this.depositOffsetList[1].id]
                    }

                    this.$watch('info.deposit', function (val) {
                        this.changeBill()
                    })
                    this.$watch('info.rent', function (val) {
                        this.changeBill()
                    })
                    this.$watch('info.rentPayMethod', function (val, oldVal) {
                        if (val === '20' || oldVal === '20') {
                            this.info.increase = []
                        }
                        if (
                            this.isRentCustom &&
                            this.info.startDate &&
                            this.info.endDate
                        ) {
                            this.modal.showRentCustom = true
                        } else {
                            this.info.mergeList = '[]'
                        }
                    })
                })
                .finally(() => {
                    this.loading = false
                })

            //zxx:20210914:合同到期时间默认递增一年
            if (!this.info.endDate) {
                this.info.endDate = dayjs(this.info.startDate)
                    .add(12, 'month')
                    .add(-1, 'day')
                    .toDate()
            }
        },
        // 租金优惠方式更改
        changeDiscountType(type) {
            this.info.discountType = type
        },
        // 交租方式更改
        changeRentMode(val) {
            changeRentMode(val, this.info, !this.isDepositPayMethodDisable)
            // 交租方式自定义，且合并账期列表为空，不更新账单
            if (!(this.isRentCustom && this.info.mergeList === '[]')) {
                this.changeBill()
            }
        },
        // 账单信息更改
        changeBill: debounce(200, function () {
            this.$emit('on-create-bills')
        }),
        // 日期更改-确定租金涨幅年限
        onChangeDate(val) {
            // 合同到期时间默认递增一年
            if (val.name === 'startDate') {
                this.info.startDate = val.startDate
            }
            if (val.name === 'endDate') {
                this.info.endDate = val.endDate
            }

            if (!this.justRead) {
                // 日期更改，合并账期列表置空,租金方式置空
                this.info.mergeList = '[]'
                if (this.isRentCustom) {
                    this.info.rentPayMethod = ''
                }
            }

            let startDate = new Date(ymd(this.info.startDate))
            let endDate = new Date(ymd(this.info.endDate))
            let saveDayDate = new Date(startDate)
            let newDate = null
            let year = 0
            if (startDate < endDate) {
                newDate = new Date(ymd(saveDayDate))
                newDate.setDate(newDate.getDate() - 1)
                while (newDate < endDate) {
                    year++
                    saveDayDate.setFullYear(saveDayDate.getFullYear() + 1)
                    newDate = new Date(ymd(saveDayDate))
                    newDate.setDate(newDate.getDate() - 1)
                }
            } else {
                year = 0
            }
            this.increaseYear = year === 0 ? year : year - 1
            this.changeBill()
        },
        // 物品清单确认
        // "parentId":"1315893483663204353","num":1,"facilityId":"1315893483826782210","price":"400","id":"","remark":""
        confirmFacilityList(list) {
            const newList = []
            list.forEach((v) => {
                newList.push({
                    parentId: v.parentId,
                    num: v.num,
                    price: v.price,
                    facilityId: v.facilityId,
                    // id: "v.id",
                    remark: this.fListRemark,
                })
            })
            const str = JSON.stringify(newList)
            this.$emit('on-facility-update', str)
        },
        // 物品清单remark更改
        remarkChange(val) {
            this.fListRemark = val
        },
        // 账期合并列表
        confirmRentCustom(mergeList) {
            this.info.mergeList = JSON.stringify(mergeList)
        },
        // 关闭弹框-清空选中的交租方式
        onCloseModal() {
            if (this.info.mergeList.length === 2) {
                this.info.rentPayMethod = ''
            }
        },
    },
}
</script>
<style lang="less" scoped></style>
